export interface FieldNote {
  id: string;
  date: string; // ISO date
  title: string;
  body: string;
  mode: "DIRECT" | "FIELD-VERIFIED";
  source: string;
  sourceUrl?: string;
  upcoming?: boolean;
  approved: boolean;
}

export const fieldNotes: FieldNote[] = [
  {
    id: "fn-2026-09-01-rhtp-first-awards",
    date: "2026-09-01",
    title: "The Governor announces the first $58 million in RHTP awards",
    body:
      "The Office of the Governor announced $45 million to JABSOM for HOME RUN workforce education and training awards and $13 million to the Department of Health for ambulances and emergency communications. These are the first awards announced against Hawaiʻi's $188.9 million first-year Rural Health Transformation Program award. No health information technology award has been announced yet.",
    mode: "DIRECT",
    source: "Office of the Governor release, 1 September 2026",
    approved: true,
  },
  {
    id: "fn-2026-09-06-star-advertiser",
    date: "2026-09-06",
    title:
      "The Star-Advertiser's doctor-shortage story cites the Task Force's community access survey",
    body:
      "The story carried a sidebar of eight figures from the Task Force's online community access survey, with the newspaper's caveat that it is an online survey of a little over 200 respondents and not a scientific poll. That caveat travels with every reuse. The survey opened on 3 June 2026, and 44 percent of early respondents identified as a doctor or clinician, so the right word is respondents, not patients. A re-tabulation with the denominator stated is in progress.",
    mode: "DIRECT",
    source: "Honolulu Star-Advertiser, 6 September 2026",
    approved: true,
  },
  {
    id: "fn-2026-09-10-capacity-test-briefing",
    date: "2026-09-10",
    title: "The Task Force briefs the state RHTP office on the Capacity Test",
    body:
      "David Isei and Esther Y. Smith, MD, met by video with the Director of the Hawaiʻi Rural Health Transformation Program and program staff to present the Rural Health Capacity Test and the Task Force's white paper, Buying Capacity. The Task Force is not an applicant for RHTP funds and asks for none.",
    mode: "DIRECT",
    source: "Task Force record of the meeting",
    approved: true,
  },
  {
    id: "fn-2026-09-12-home-run-applications",
    date: "2026-09-12",
    title:
      "The RHTP program office reports 597 HOME RUN applications at the Hawaiʻi Health Workforce Summit",
    body:
      "On a panel at the summit, the state program office and the initiative leads gave the first public status figures. HOME RUN education and training awards had 597 applications as of 10 September, 453 of them complete, with the first payments beginning. Rural Respite facilities on Hawaiʻi Island and Kauaʻi are expected to open toward the end of the year. A purchase order has been signed for mobile dialysis units to be distributed across the islands. Pili Ola's $12.5 million is spread across ten telehealth programs. The program office has grown from two staff to four, has finalized a six-month communication plan, and intends to publish a dashboard. The office also said that workforce spending not sanctioned by HOME RUN, and payment models not sanctioned by RVBI, are not eligible for RHTP funds.",
    mode: "FIELD-VERIFIED",
    source:
      "RHTP panel, Hawaiʻi Health Workforce Summit, 12 September 2026, from the session recording; figures as stated by program leadership",
    approved: true,
  },
  {
    id: "fn-2026-09-12-governor-green",
    date: "2026-09-12",
    title: "Governor Green, on Medicare reimbursement and primary care",
    body:
      "In a conversation with Nadine Tenn Salle, MD, at the summit, Governor Green said Hawaiʻi's Medicare reimbursement sits near the bottom of the states and that moving it toward the national median is a four-year goal. Asked from the floor by Scott Grosskreutz, MD, about raising primary care spending as a share of total health spending this year, the Governor answered that the backbone of primary care has to be plussed up, especially where there are access issues. He also said the administrative burden on practices should be cut in half as part of any change to the system. The Task Force's 2027 primary care investment proposal addresses the first of those.",
    mode: "DIRECT",
    source:
      "Hawaiʻi Health Workforce Summit, 12 September 2026, from the session recording; paraphrased, not quoted",
    approved: true,
  },
  {
    id: "fn-2026-09-18-ache-panel",
    date: "2026-09-18",
    title:
      "ACHE panel at the HAHRM and ACHE Risk Management Leadership Conference",
    body:
      "David Isei moderated the panel on Friday 18 September, 9:30 to 11:00, at the Imin Center, with Esther Y. Smith, MD, Scott Grosskreutz, MD, and the Administrator of the State Health Planning and Development Agency, with a live demonstration of the Hawaiʻi Healthcare Intelligence Platform.",
    mode: "DIRECT",
    source: "HAHRM and ACHE conference program",
    approved: true,
  },
];
